import Swiper from "swiper/bundle";

export const slider = () => {
  const elms = {
    caseCard: ".swiper-js",
  };

  const init = () => {
    caseSlider();
  };

  const caseSlider = () => {
    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(elms.caseCard, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      slidesPerView: 3,
      spaceBetween: 30,
      scrollbar: {
        hide: true,
      },
      //   centeredSlides: true,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    });
  };

  init();
};
